import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }
    update( $args ){
        this.el.classList.toggle( 'has-photo', $args );
        this.el.querySelector( 'img' ).src = $args;
    }
    init() {}
    destroy(){}
}
